export const FETCH_QUERY_NOA_FAILURE = "FACTORING/FETCH_QUERY_NOA_FAILURE";
export const FETCH_QUERY_NOA_REQUEST = "FACTORING/FETCH_QUERY_NOA_REQUEST";
export const FETCH_QUERY_NOA_SUCCESS = "FACTORING/FETCH_QUERY_NOA_SUCCESS";
